import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import "./style.css";

// redux imports
import {
  reminderTxnView,
  reminderTxnDelete,
} from "../../redux/features/reminderTransaction";
import {
  disableSwitcher,
  enableSwitcher,
} from "../../redux/features/multiEntitySwitcher/multiEntitySwitcher";

// components imports
import Loader from "../../components/Loader/Index";
import CommonToast from "../../components/_utils/CommonToast";
import SmallPopup from "../../components/_utils/CommonSmallPopup";
import SvgComponent from "../../components/_utils/SVGComponent/index.jsx";
import SwitcherTabs from "../../components/_utils/CommonButtons/SwitcherTabs/index.jsx";
import CommonReminderCard from "../../components/_utils/CommonReminderCard/index.jsx";
import ReminderFormPopup from "../../components/_utils/ReminderFormPopup/index.jsx";
import CommonReminderRedirectPopup from "../../components/_utils/CommonPopups/CommonReminderRedirectPopup/index.jsx";
import {
  GlobalConfiguration,
  IntervalConfiguration,
  PaginationConfiguration,
} from "../../utils/configurationProvider.js";
import useCustomSearchParams from "../../utils/useCustomSearchParams.js";
import PaginationComponent from "../../components/_utils/PaginationComponent/index.jsx";
import PrimaryButton from "../../components/_utils/CommonButtons/PrimaryButton/index.jsx";
import TopNavComponent from "../../components/_utils/CommonTopNav/TopNavComponent/index.jsx";
import ICONS from "../../assets/Icons/index.js";

const ReminderTransaction = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const scrollRef = useRef();

  const { markerData } = useSelector((s) => s.multiEntitySwitcherSlice);
  const services = useSelector((state) => state.refreshToken.services);
  const hasModService = services?.includes("AReminder");

  const hasCreateService = services?.includes("CBeneficiaryTxn");
  const hasCreateInternalService = services?.includes("CInternalTxn");

  const { reminderTxnViewLoading } = useSelector(
    (state) => state.reminderTxnSlice,
  );

  const dropdownOptions = PaginationConfiguration.paginationOptions;
  const { searchParam, handleSearchParams, handleClearSearchParam } =
    useCustomSearchParams({
      pageno: GlobalConfiguration.lengthCheckOne,
      pagesize: dropdownOptions[0],
    });
  const [toggleCurrent, setToggleCurrent] = useState(true);
  const [createShow, setCreateShow] = useState(false);
  const [toggleFuture, setToggleFuture] = useState(false);
  const [toggleExpired, setToggleExpired] = useState(false);
  const [loading, setLoading] = useState(false);
  const [reminderDeletePrompt, setReminderDeletePrompt] = useState(false);
  const [reminderData, setReminderData] = useState([]);
  const [mainData, setMainData] = useState([]);
  const [showInnerSearchBar, setShowInnerSearchBar] = useState(false);
  const [txnId, setTxnId] = useState(null);
  const [currentPage, setCurrentPage] = useState(
    searchParam.get("pageno") || GlobalConfiguration.lengthCheckOne,
  );
  const [isOpen, setIsOpen] = useState(false);
  const [pageSize, setPageSize] = useState(
    searchParam.get("pagesize") || dropdownOptions[0],
  );
  const [selectedValue, setSelectedValue] = useState(
    searchParam.get("pagesize") || dropdownOptions[0],
  );

  const [startDateFilter, setStartDateFilter] = useState(
    searchParam.get("date") || "",
  );
  const [endDateFilter, setEndDateFilter] = useState(
    searchParam.get("date") || "",
  );
  const [remarkText, setRemarkText] = useState(searchParam.get("search") || "");
  const [active, setActive] = useState("");
  const [searchText, setSearchText] = useState("");
  const [currentCount, setCurrentCount] = useState(0);
  const [futureCount, setFutureCount] = useState(0);
  const [expiredCount, setExpiredCount] = useState(0);
  const [selectedTxnData, setSelectedTxnData] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [isDeleteLoading, setIsDeleteLoading] = useState(false);
  const [showAmtFilterDiv, setShowAmtFilterDiv] = useState(false);
  const [isAmtFilterApplied, setIsAmtFilterApplied] = useState(false);
  const [amountLimit, setAmountLimit] = useState({
    min: "",
    max: "",
  });

  const handleToggle = (type) => {
    setToggleCurrent(type === "current");
    setToggleFuture(type === "future");
    setToggleExpired(type === "expired");
    setReminderData([]);
  };

  const navDetails = {
    txnDetails: {
      reminderRemark: selectedTxnData?.reminderRemark,
      reminderAmount: selectedTxnData?.reminderAmount || "",
    },
    flowType: "ReminderFlow",
  };

  useEffect(() => {
    document.body.style.overflow = "hidden";

    return () => {
      document.body.style.overflow = "auto";
    };
  }, []);

  const chipsArray = [
    {
      text: "Beneficiary Transactions",
      imgUrl:
        "https://q2pay.in/new_assets/common/home_dashboard_icons/beneficiary_transaction_with_blue_circle.svg",
      disabled: !hasCreateService,
      onClick: () => {
        if (!hasCreateService) {
          navigate("/feature_not_assigned", {
            state: { unavailableService: "CBeneficiaryTxn" },
          });
        } else {
          navigate(
            "/beneficiary_transaction_dashboard/create_beneficiary_transaction",
            {
              state: navDetails,
            },
          );
        }
      },
    },
    {
      text: "Internal Transactions",
      imgUrl:
        "https://q2pay.in/new_assets/common/home_dashboard_icons/internal_transaction_with_blue_circle.svg",
      disabled: !hasCreateInternalService,
      onClick: () => {
        if (!hasCreateInternalService) {
          navigate("/feature_not_assigned", {
            state: { unavailableService: "CInternalTxn" },
          });
        } else {
          sessionStorage.removeItem("recreate_int_txn_id");
          navigate(
            "/internal_transaction_dashboard/create_internal_transaction",
            {
              state: navDetails,
            },
          );
        }
      },
    },
  ];

  const handleDateformat = (dates) => {
    const date = new Date(dates);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    const formattedDate = `${day}/${month}/${year}`;
    return formattedDate;
  };

  const handleReminderAction = async () => {
    try {
      setLoading(true);

      let queryParams = {
        page_no: currentPage,
        page_size: pageSize,
      };

      if (toggleCurrent) {
        queryParams.search_string = "current";
      } else if (toggleFuture) {
        queryParams.search_string = "future";
      } else if (toggleExpired) {
        queryParams.search_string = "past";
      }

      if (startDateFilter && endDateFilter) {
        queryParams.start_date = handleDateformat(startDateFilter);
        queryParams.end_date = handleDateformat(endDateFilter);
      }

      if (remarkText) {
        queryParams.remark = remarkText;
      }

      queryParams.min_amount = isAmtFilterApplied ? amountLimit.min : undefined;
      queryParams.max_amount = isAmtFilterApplied ? amountLimit.max : undefined;

      const response = await dispatch(reminderTxnView(queryParams));
      const newData = response?.payload?.reminders;
      const countData = response?.payload?.summary;
      setMainData(response?.payload);
      setReminderData(newData || []);
      if (countData) {
        setCurrentCount(countData?.current_reminders_count);
        setFutureCount(countData?.future_reminders_count);
        setExpiredCount(countData?.past_reminders_count);
      }
    } catch (error) {
      setReminderData([]);
      setMainData([]);
      setCurrentCount(0);
      setFutureCount(0);
      setExpiredCount(0);
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  const handleFilterDateRange = (date) => {
    if (date) {
      const [start, end] = date;

      setStartDateFilter(start);
      setEndDateFilter(end);
    } else {
      setStartDateFilter("");
      setEndDateFilter("");
    }
  };

  const showToast = (message) => {
    CommonToast({
      text: message,
      icon: "https://q2pay.in/new_assets/gifs/inputloader_white.gif",
      variant: "var(--processing)",
      buttonNeeded: false,
      btnProps: {
        enabledBgColor: "var(--primary-bg)",
        enabledTextColor: "var(--text-primary)",
        btnText: "",
        handleFunction: () => {},
        icon: "",
        btnType: "button",
        isDisabled: false,
        hoverOption: "white",
      },
    });
  };

  const handleDeleteReminder = async (id) => {
    try {
      setIsDeleteLoading(true);

      showToast("Deleting reminder.");

      const resultAction = await dispatch(reminderTxnDelete(id));
      const data = resultAction?.payload;

      if (data?.errors?.user_unauthorized?.[0]) {
        navigate("/feature_not_assigned", {
          state: {
            unavailableService: "AReminder",
          },
        });
        return;
      }

      if (data?.errors?.base?.length > GlobalConfiguration?.lengthCheckZero) {
        toast.dismiss();
        data.errors.base.forEach((msg) => {
          CommonToast({
            text: msg,
            icon: ICONS?.ERROR_WHITE_CIRCLE,
            variant: "var(--error)",
            btnProps: {
              isDisabled: false,
              enabledTextColor: "var(--text-primary)",
              enabledBgColor: "var(--primary-bg)",
            },
          });
        });
        return;
      }

      if (data?.status === true) {
        const updatedReminderData = reminderData?.filter(
          (item) => item.id !== id,
        );
        setReminderData(updatedReminderData);
        toast.dismiss();
        CommonToast({
          text: "Reminder deleted successfully.",
          icon: "https://q2pay.in/new_assets/common/approval/select_all_with_white_filled_circle.svg",
          variant: "var(--success)",
          btnProps: {
            isDisabled: false,
            enabledTextColor: "var(--text-primary)",
            enabledBgColor: "var(--primary-bg)",
          },
        });
        handleReminderAction();
      }

      if (data?.status === false && !data?.errors?.base) {
        toast.dismiss();
        CommonToast({
          text: data?.errors?.base || "Failed to delete reminder",
          icon: ICONS?.ERROR_WHITE_CIRCLE,
          variant: "var(--error)",
          btnProps: {
            isDisabled: false,
            enabledTextColor: "var(--text-primary)",
            enabledBgColor: "var(--primary-bg)",
          },
        });
      }
    } catch (error) {
      toast.dismiss();
      CommonToast({
        text: "Something went wrong",
        icon: ICONS?.ERROR_WHITE_CIRCLE,
        variant: "var(--error)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
    } finally {
      setIsDeleteLoading(false);
      setReminderDeletePrompt(false);
    }
  };

  const handleSubmit = (key, value) => {
    handleSearchParams(key, value);
  };

  const handleClearParams = (e) => {
    handleClearSearchParam();

    if (showInnerSearchBar) return;
    setRemarkText("");
    setSearchText("");
    setStartDateFilter("");
    setEndDateFilter("");
    setIsAmtFilterApplied(false);
    setAmountLimit({ min: "", max: "" });
  };

  const handleSelect = (value) => {
    handleSubmit("pagesize", value);
    setCurrentPage(GlobalConfiguration.lengthCheckOne);
    setSelectedValue(value);
    setPageSize(value);
    setIsOpen(!isOpen);
  };

  const handlePagination = (page) => {
    handleSubmit("pageno", page);
    setCurrentPage(page);
  };

  useEffect(() => {
    dispatch(enableSwitcher());

    return () => {
      dispatch(disableSwitcher());
    };
  }, [dispatch]);

  useEffect(() => {
    handleReminderAction();
  }, [
    currentPage,
    pageSize,
    toggleCurrent,
    toggleFuture,
    toggleExpired,
    markerData,
    remarkText,
    startDateFilter,
    endDateFilter,
    amountLimit,
  ]);

  return (
    <>
      <div
        className={`absolute bg-primary-nav ${showInnerSearchBar ? "z-z-index-content pointer-events-none" : "z-z-index-max"}  
               bottom-bottom-base w-full rounded-none`}
      >
        {reminderData?.length > GlobalConfiguration?.lengthCheckZero && (
          <PaginationComponent
            handleSelect={handleSelect}
            selectedValue={selectedValue}
            data={mainData}
            pageSize={pageSize}
            dropdownOptions={dropdownOptions}
            handlePagination={handlePagination}
            currentPage={currentPage}
            setIsOpen={setIsOpen}
          />
        )}
      </div>
      {createShow && (
        <div className="fixed top-left-base left-left-base w-screen h-screen z-z-index-max bg-PopUp-BackDrop bg-opacity-dark-opacity">
          <ReminderFormPopup
            handleReminderAction={handleReminderAction}
            navigate={navigate}
            setCreateShow={setCreateShow}
          />
        </div>
      )}
      {showModal && (
        <div className="fixed top-left-base left-left-base w-screen h-screen z-z-index-max bg-PopUp-BackDrop bg-opacity-dark-opacity">
          <CommonReminderRedirectPopup
            headerTitle="Select transaction type"
            chipsArray={chipsArray}
            closeiconhandleFunction={() => setShowModal(false)}
          />
        </div>
      )}
      {reminderDeletePrompt && (
        <>
          <div className="fixed top-left-base left-left-base w-screen h-screen z-z-index-max bg-PopUp-BackDrop bg-opacity-dark-opacity">
            <SmallPopup
              secondHeaderTitle={
                "Are you sure you want to delete this reminder ?"
              }
              btnOneText="Cancel"
              btnOneHandleFunction={() => {
                setReminderDeletePrompt(false);
              }}
              btnOneEnabledBgColor="var(--primary-bg)"
              btnOneOutLineColor="var(--text-primary)"
              btnOneEnabledTextColor="var(--text-primary)"
              btnOneIsDisabled={isDeleteLoading}
              btnOneHoverOption="white"
              btnTwoText="Delete"
              btnTwoHandleFunction={() => {
                handleDeleteReminder(txnId);
              }}
              btnTwoEnabledBgColor="var(--negative-act)"
              btnTwoEnabledTextColor="var(--text-primary)"
              btnTwoIsDisabled={false}
              btnTwoDisabledBgColor="var(--text-disabled)"
              btnTwoIsLoaderNeeded={true}
              btnTwoIsLoading={isDeleteLoading}
              btnTwoHoverOption="black"
              btnTwoInActiveVariantNeeded={true}
            />
          </div>
        </>
      )}

      <div className="h-screen overflow-hidden flex flex-col">
        <div className="Qsmd:h-navbar-breadcrumb-height bg-primary-nav flex-shrink-0"></div>
        <TopNavComponent
          topNavCtaBtnWithIcon1Props={{
            btnText: "Add reminder",
            btnType: "button",
            handleFunction: (e) => {
              if (hasModService) {
                setCreateShow(true);
              } else {
                e.stopPropagation();
                navigate("/feature_not_assigned", {
                  state: {
                    unavailableService: "AReminder",
                  },
                });
              }
            },
            isDisabled: !hasModService,
            enabledTextColor: "var(--primary-bg)",
            disabledTextColor: null,
            enabledBgColor: "var(--text-primary)",
            disabledBgColor: null,
            isLoading: false,
            outLineColor: null,
            hoverOption: "black",
            buttonRef: null,
            fullWidthRequired: null,
            inActiveVariantNeeded: null,
            isLoaderNeeded: null,
            icon: "https://q2pay.in/new_assets/common/settings/add_button_white.svg",
            imgColor: "var(--primary-bg)",
            iconToBeAlign: "right",
          }}
          filteredSearchProps={{
            setShowInnerSearchBar: setShowInnerSearchBar,
            onSearchInput: (e) => setSearchText(e),
            searchInputRef: null,
            searchText: searchText,
            searchPlaceholder: "Search reminders",
            filterPlaceholder: "reminder remark",
            isSearchDisabled: false,

            filterItems: [
              {
                name: "Reminder remark",
                isMulti: false,
                value: remarkText,
                setValue: (val) => {
                  handleSubmit("search", val);
                  setRemarkText(val);
                },
                isDropdown: false,
                isDisabled: false,
              },
            ],
            filters: [
              {
                name: "Date range",
                filterType: "calender",
                variant: "range",
                size: "small",
                value: startDateFilter && endDateFilter,
                isDisable: false,
                startDate: startDateFilter,
                endDate: endDateFilter,
                maxDate: null,
                handleChange: (date) => {
                  setCurrentPage(GlobalConfiguration.lengthCheckOne);
                  handleSubmit("date", date);
                  handleFilterDateRange(date);
                },
              },
              {
                name: "Amount range",
                filterType: "amountRange",
                variant: "range",
                size: "small",
                rangeValue: amountLimit,
                value: amountLimit?.max && amountLimit?.min,
                handleChange: setAmountLimit,
                setShowAmtFilterDiv: setShowAmtFilterDiv,
                setIsAmtFilterApplied: setIsAmtFilterApplied,
              },
            ],
            loading: false,
            inputData: [],
            setShowInnerSearchBar: setShowInnerSearchBar,
            active: active,
            setActive: setActive,
            isShowFilter: true,
            isShowSortBy: false,
            showSearchBar: false,
            isFilterClearAllDisabled: !(
              (startDateFilter && endDateFilter) ||
              isAmtFilterApplied
            ),
            isSearchClearAllDisabled: !remarkText,
          }}
          BottomSubText={
            "Set a reminder to make the transaction on the specified date."
          }
          BottomSubTextVaraint="secondary"
          ispagination={
            reminderData?.length <= GlobalConfiguration.lengthCheckZero
              ? false
              : true
          }
        />
        <div
          className={
            showInnerSearchBar
              ? "overflow-y-hidden h-screen  flex flex-col opacity-dark-opacity  bg-PopUp-BackDrop pointer-events-none w-full z-z-index-content Qsmd:z-z-index-content"
              : !reminderData?.length
                ? "overflow-y-hidden h-screen mt-margin-xs"
                : `flex flex-col flex-1 overflow-hidden Qsmd:flex-row`
          }
        >
          <div
            ref={scrollRef}
            className={`${showInnerSearchBar ? "bg-PopUp-BackDrop  overflow-y-hidden opacity-light-opacity" : ""} w-width-full flex flex-col flex-1 overflow-y-auto h-height-full Qsmd:pb-[var(--pagination-height)] mb-topnav-bottom-height Qsmd:mb-margin-base`}
            style={{
              scrollPaddingTop: "var(--padding-md)",
              scrollPaddingBottom: "var(--padding-md)",
            }}
          >
            <div
              className={`${showInnerSearchBar && "opacity-light-opacity bg-PopUp-BackDrop z-z-index-base pointer-events-none relative"} py-padding-md max-w-max-content-width w-width-full mx-auto justify-start px-padding-md xl:px-padding-base`}
            >
              <SwitcherTabs
                initialActiveTab={"current"}
                tabs={[
                  {
                    label: `Current - ${currentCount}`,
                    key: "current",
                    handler: () => {
                      if (!toggleCurrent) handleToggle("current");
                    },
                  },
                  {
                    label: `Future - ${futureCount}`,
                    key: "future",
                    handler: () => {
                      if (!toggleFuture) handleToggle("future");
                    },
                  },
                  {
                    label: `Expired - ${expiredCount}`,
                    key: "expired",
                    handler: () => {
                      if (!toggleExpired) handleToggle("expired");
                    },
                  },
                ]}
                isDisabled={showInnerSearchBar}
                swicherTabBgColor={"var(--primary-card)"}
              />
            </div>

            <div
              className={`${showInnerSearchBar ? "bg-PopUp-BackDrop opacity-light-opacity overflow-y-hidden" : ""} flex-1`}
            >
              {reminderTxnViewLoading ? (
                <div className="loader-container m-auto justify-center items-center flex h-height-full">
                  <Loader />
                </div>
              ) : reminderData &&
                reminderData.length > GlobalConfiguration?.lengthCheckZero ? (
                <CommonReminderCard
                  filterRef={scrollRef}
                  data={reminderData}
                  toggle={toggleExpired}
                  txnId={setTxnId}
                  hasModService={hasModService}
                  navigate={navigate}
                  setShowModal={setShowModal}
                  setSelectedTxnData={setSelectedTxnData}
                  setReminderDeletePrompt={setReminderDeletePrompt}
                />
              ) : (remarkText ||
                  startDateFilter ||
                  endDateFilter ||
                  amountLimit) &&
                !reminderTxnViewLoading &&
                !loading ? (
                <div className="flex flex-col items-center justify-center h-height-full gap-gap-sm">
                  <SvgComponent
                    url={
                      "https://q2pay.in/new_assets/graphics/no_data/no_data_found.svg"
                    }
                    height={"var(--graphic-square-height-md)"}
                    width={"var(--graphic-width-md)"}
                  />
                  <p className="text-font-sm text-text-primary">
                    No data found.
                  </p>

                  {(remarkText ||
                    startDateFilter ||
                    endDateFilter ||
                    isAmtFilterApplied) && (
                    <PrimaryButton
                      isDisabled={showInnerSearchBar}
                      enabledBgColor="var(--primary-act)"
                      btnText="Clear parameters"
                      enabledTextColor="var(--text-primary)"
                      handleFunction={handleClearParams}
                      hoverOption="white"
                    />
                  )}
                </div>
              ) : !hasModService ||
                (reminderData?.length ===
                  GlobalConfiguration?.lengthCheckZero &&
                  !reminderTxnViewLoading &&
                  !loading) ? (
                <div className="flex flex-col items-center justify-center h-height-full gap-gap-sm">
                  <SvgComponent
                    url={
                      "https://q2pay.in/new_assets/graphics/general/reminder.svg"
                    }
                    height={"var(--graphic-square-height-md)"}
                    width={"var(--graphic-width-md)"}
                  />
                  <p className="text-font-sm text-text-primary">
                    {!hasModService
                      ? "No reminders found."
                      : toggleCurrent
                        ? "There are no reminders scheduled for today."
                        : toggleFuture
                          ? "There are no reminders scheduled for future."
                          : "There are no expired reminders."}
                  </p>
                </div>
              ) : null}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ReminderTransaction;
